<template>
  <div v-redirect-if-no-permission:VACATIONS>
    <v-tabs color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab" @click="getUpcomingVacations">
        {{ $t("settings.vacations.upcomingVacations") }}
      </v-tab>
      <v-tab-item>
        <div>
          <v-form ref="form">
            <v-container>
              <!-- Date Range Picker Component -->
              <v-layout wrap>
                <v-flex md2 sm12>
                  <choose-date
                    clearable
                    :label="$t('settings.vacations.startDate')"
                    v-model="from"
                  ></choose-date>
                </v-flex>
                <v-flex md2 sm12>
                  <choose-date
                    clearable
                    :label="$t('settings.vacations.endDate')"
                    v-model="to"
                  ></choose-date>
                </v-flex>
                <v-flex md2 sm12>
                  <!-- Autocomplete Component for Captain selection -->
                  <v-autocomplete
                    v-model="selectedCaptainuP"
                    clearable
                    dense
                    :items="captains"
                    :loading="loading"
                    :label="$t('settings.vacations.captain')"
                    item-text="text"
                    item-value="id"
                    :search-input.sync="searchCaptainParamUp"
                    :placeholder="$t('settings.vacations.searchCaptain')"
                    no-filter
                    :debounce-search="250"
                    ><template slot="item" slot-scope="captains">
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="
                            captains.item.first_name +
                            ' ' +
                            captains.item.last_name
                          "
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="captains.item.username"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                  <!-- Autocomplete Item Template -->
                  <template slot="item" slot-scope="captain">
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="captain.item.full_name"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="captain.item.username"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-flex>
                <v-flex md2 sm12 ma-2>
                  <!-- Search Button -->
                  <v-btn
                    v-if="hasSearchFilters"
                    color="primary"
                    dark
                    class="mb-2 cbtn"
                    @click="getUpcomingVacations()"
                    :loading="loading"
                    >{{ $t("common.search") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </div>
        <!-- Data Table for Upcoming Vacations -->
        <v-data-table
          :headers="headers"
          :items="vacations"
          :rows-per-page-items="[5, 10, 15, 25, 100]"
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs">{{ props.item.id }}</td>
              <td class="text-xs">{{ props.item.username }}</td>
              <td class="text-xs">{{ moment(props.item.start_date).format("DD-MM-YYYY") }}</td>
              <td class="text-xs">{{ moment(props.item.end_date).format("DD-MM-YYYY") }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab :key="2" ripple active-class="tab" @click="getPastVacations">
        {{ $t("settings.vacations.pastVacations") }}
      </v-tab>
      <v-tab-item>
        <div>
          <v-form ref="form">
            <v-container>
              <!-- Date Range Picker Component -->
              <v-layout wrap>
                <v-flex md2 sm12>
                  <choose-date
                    clearable
                    :label="$t('settings.vacations.startDate')"
                    v-model="from"
                  ></choose-date>
                </v-flex>
                <v-flex md2 sm12>
                  <choose-date
                    clearable
                    :label="$t('settings.vacations.endDate')"
                    v-model="to"
                  ></choose-date>
                </v-flex>
                <v-flex md2 sm12>
                  <!-- Autocomplete Component for Captain selection -->
                  <v-autocomplete
                    v-model="selectedCaptain"
                    clearable
                    dense
                    :items="captains"
                    :loading="loading"
                    :label="$t('settings.vacations.captain')"
                    item-text="text"
                    item-value="id"
                    :search-input.sync="searchCaptainParam"
                    :placeholder="$t('settings.vacations.searchCaptain')"
                    no-filter
                    :debounce-search="250"
                    ><template slot="item" slot-scope="captains">
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="
                            captains.item.first_name +
                            ' ' +
                            captains.item.last_name
                          "
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="captains.item.username"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md2 sm12 ma-2>
                  <!-- Search Button -->
                  <v-btn
                    v-if="hasSearchFilters"
                    color="primary"
                    dark
                    class="mb-2 cbtn"
                    @click="getPastVacations"
                    :loading="loading"
                    >{{ $t("common.search") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </div>
        <!-- Data Table for Past Vacations -->
        <v-data-table
          :headers="headers"
          :items="vacations"
          :rows-per-page-items="[5, 10, 15, 25, 100]"
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs">{{ props.item.id }}</td>
              <td class="text-xs">{{ props.item.username }}</td>
              <td class="text-xs">{{ moment(props.item.start_date).format("DD-MM-YYYY") }}</td>
              <td class="text-xs">{{ moment(props.item.end_date).format("DD-MM-YYYY") }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import moment from "moment";
import DataTable from "@/components/monaco/DataTable";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "Vacations",
  components: { DataTable, ChooseDate },
  data() {
    return {
      searchCaptainParam: "",
      searchCaptainParamUp: "",
      from: null,
      to: null,
      selectedCaptain: null,
      selectedCaptainuP: null,
      loading: false,
      vacations: [],
      captains: [],
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("settings.vacations.id"), value: "id", sortable: false },
        { text: this.$t("settings.vacations.userName"), value: "username", sortable: false },
        { text: this.$t("settings.vacations.startDate"), value: "start_date", sortable: false },
        { text: this.$t("settings.vacations.endDate"), value: "end_date", sortable: false },
      ];
    },
    hasSearchFilters() {
      return !!this.from || !!this.to;
    },
  },
  mounted() {
    const selectedDay = moment().format("YYYY-MM-DD");
    this.from = selectedDay;
    this.to = selectedDay;
    this.getUpcomingVacations();
  },
  methods: {
    getUsers() {
      if (!this.searchUserParam) {
        return;
      }
      this.loading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchUserParam);
      this.axios
        .get(`user`, { params })
        .then((res) => {
          this.users = res.data.data.data.map((item) => ({
            text: `${item.username || ""}` + " " + `${item.first_name || ""}`,
            ...item,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCaptains(upcoming) {
      // if (!this.searchCaptainParam && !this.searchCaptainParamuP) {
      //   return;
      // }
      this.loading = true;
      const params = new URLSearchParams();
      if(upcoming == true)
        params.append("search", this.searchCaptainParamUp);
      else
        params.append("search", this.searchCaptainParam);
      this.axios
        .get(`captain/search`, { params })
        .then((res) => {
          this.captains = res.data.data.map((item) => ({
            text: `${item.username || ""}`,
            ...item,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPastVacations() {
      var params = new URLSearchParams();
      if (this.selectedCaptain != null) {
        params.append("captain_id", this.selectedCaptain);
      }
      if (this.from != null && this.to != null) {
        params.append("start_date", this.from);
        params.append("end_date", this.to);
      }
      params.append("type", "past_vacations");
      this.loading = true;
      this.axios
        .get(`vacations`, { params })
        .then((res) => {
          this.vacations = res.data.data.data;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUpcomingVacations() {
      var params = new URLSearchParams();
      if (this.selectedCaptainuP != null) {
        params.append("captain_id", this.selectedCaptainuP);
      }
      if (this.from != null && this.to != null) {
        params.append("start_date", this.from);
        params.append("end_date", this.to);
      }
      params.append("type", "upcoming_vacations");
      this.loading = true;
      this.axios
        .get(`vacations`, { params })
        .then((res) => {
          this.vacations = res.data.data.data;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    searchCaptainParam() {
      this.getCaptains(false);
    },
    searchCaptainParamUp() {
      this.getCaptains(true);
    }
  },
};
</script>
